<template>
  <div class="relative" :style="{width, height }">
    <div id="reactive-after" class="relative reactive-after">
      <img
        id="interactive-happy-main"
        class="absolute z-10 w-[86%] top-5 right-5"
        src="../../../assets/img/login/interactive/interactive-happy-main.png"/>
      <img
        id="interactive-happy-bg"
        class="absolute z-1 w-[92%]"
        src="../../../assets/img/login/interactive/interactive-happy-bg.png"/>
      <img
        id="interactive-happy-message1"
        class="absolute z-20 top-6"
        src="../../../assets/img/login/interactive/interactive-happy-message1.png"/>
      <img
        id="interactive-happy-message2"
        class="absolute z-20 top-12 left-0"
        src="../../../assets/img/login/interactive/interactive-happy-message2.png"/>
    </div>
    <div id="reactive-busy" class="relative">
      <img
        class="absolute z-10 w-[95%] top-4 right-8"
        src="../../../assets/img/login/interactive/interactive-busy-main.png"/>
      <img
        class="absolute z-1 w-[92%]"
        src="../../../assets/img/login/interactive/interactive-busy-bg.png"/>
      <img
        id="interactive-busy-message1"
        class="absolute z-20 top-10 right-6 w-28"
        src="../../../assets/img/login/interactive/interactive-busy-message1.png"/>
      <img
        id="interactive-busy-message2"
        class="absolute z-20 top-[4.25rem] left-4 w-28"
        src="../../../assets/img/login/interactive/interactive-busy-message2.png"/>
      <img
        id="interactive-busy-message3"
        class="absolute z-20 top-36 left-1 w-28"
        src="../../../assets/img/login/interactive/interactive-busy-message3.png"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {timeline} from "motion"
import {onMounted} from "vue";

defineProps({
  height: {
    required: false,
    type: String,
    default: '380px'
  },
  width: {
    required: false,
    type: String,
    default: '380px'
  },
})

onMounted(() => {
  timeline([
    ['#reactive-after img', {
      opacity: 1,
    }, {easing: 'ease-in-out', duration: 0.3}],
    ['#reactive-after', {
      transform: ['perspective(650px) rotateX(5deg) rotateY(-90deg)', 'perspective(650px) rotateX(-5deg) rotateY(20deg)'],
    }, {easing: 'ease-in-out', duration: 0.5, at: '<'}],
    ['#reactive-after', {
      transform: ['perspective(650px) rotateX(-5deg) rotateY(20deg)', 'perspective(650px) rotateX(5deg) rotateY(-20deg)',],
    }, {easing: 'ease-in-out', duration: 2}],
    ['#reactive-after', {
      transform: ['perspective(650px) rotateX(5deg) rotateY(-20deg)', 'perspective(650px) rotateX(-5deg) rotateY(90deg)'],
    }, {easing: 'ease-in', duration: 0.5}],
    ['#reactive-after img', {
      opacity: 0,
    }, {easing: 'ease-in-out', duration: 0.2, at: "<", delay: 0.3}],
    ['#reactive-busy img', {
      opacity: 1,
    }, {easing: 'ease-in-out', duration: 0.2}],
    ['#reactive-busy', {
      transform: ['perspective(650px) rotateX(-5deg) rotateY(-90deg)', 'perspective(650px) rotateX(5deg) rotateY(20deg)',],
    }, {easing: 'ease-in-out', duration: 0.8, at: "<",}],
    ['#reactive-busy', {
      transform: ['perspective(650px) rotateX(5deg) rotateY(20deg)', 'perspective(650px) rotateX(-5deg) rotateY(-20deg)'],
    }, {easing: 'ease-in-out', duration: 2}],
    ['#reactive-busy', {
      transform: ['perspective(650px) rotateX(-5deg) rotateY(-20deg)', 'perspective(650px) rotateX(5deg) rotateY(90deg)',],
    }, {easing: 'ease-in', duration: 0.5}],
    ['#reactive-busy img', {
      opacity: 0,
    }, {easing: 'ease-in-out', duration: 0.2, at: "<", delay: 0.3}],
  ], {
    repeat: Infinity,
  })
})
</script>

<style scoped lang="scss">
#reactive-after, #reactive-busy {
  transform-style: preserve-3d;

  #interactive-happy-message2,
  #interactive-happy-message1,
  #interactive-busy-message1,
  #interactive-busy-message2,
  #interactive-busy-message3 {
    transform: translateZ(40px);
  }

  img {
    opacity: 0;
  }
}

#reactive-busy {
  //transform: rotateY(-90deg)
}

</style>
